<template lang="pug">
  div
    div(v-if="useVirtualScroll", v-bind:style="{'height': height.replace(';', '')}")
      VirtualScroller(
        class="selector-pw-container", :items="items", :item-height="itemHeight", buffer="200"
        pool-size="300", ref="scroller")

        // use this slot to show before in the list. eg: Selecionar todos
        template(slot="before-content")
          slot(name="beforeContent", :focusEl="focusEl")

        template(slot-scope="{ item, itemIndex }")
          SelectorItem(:item="item", :index="itemIndex", :focusEl="focusEl")
            slot(:index="itemIndex", :item="item", :focusEl="focusEl")

    div(v-else="")
      slot(name="beforeContent", :focusEl="focusEl")
      SelectorItem(v-for="(item, itemIndex) in items", :key="itemIndex", :item="item",
        :index="itemIndex", :focusEl="focusEl", :useVirtualScroll="useVirtualScroll")
        slot(:index="itemIndex", :item="item", :focusEl="focusEl")

</template>

<script type="text/jsx">
import VirtualScroller from 'vue-virtual-scroller/src/components/VirtualScroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import Vue from 'vue'
import Jquery from 'jquery'

export const SelectorItem = Vue.component('SelectorPWItem', {
  functional: true,
  props: {
    item: {required: true},
    index: {required: true},
    onSelect: {type: Function},
    onDelete: {type: Function},
    focusEl: {type: Function},
    prevFocusForce: {type: Element},
    useVirtualScroll: {type: Boolean, 'default': true},
    level: {'default': 1}
  },
  render (h, context) {
    const {index, onSelect, item, prevFocusForce, focusEl, useVirtualScroll, onDelete, level} = context.props
    const $slots = context.slots()

    function keypress (e) {
      e.stopPropagation()
      e.preventDefault()

      let DELETE = ['Delete', 'Backspace'].includes(e.key)
      let SELECT = [' ', 'Enter'].includes(e.key)
      let ARROW = ['ArrowLeft', 'ArrowRight'].includes(e.key)

      let FORCEFOCUSOUT = (['F', 'f'].includes(e.key) && e.shiftKey)
      let FOCUSOUTPREV = ((e.key === 'ArrowUp' || (e.key === 'Tab' && e.shiftKey)) && index < 1) || FORCEFOCUSOUT

      const FOCUSNEXT = (e.key === 'ArrowDown' || e.key === 'Tab')
      const FOCUSPREV = (e.key === 'ArrowUp' || (e.key === 'Tab' && e.shiftKey))

      if (FORCEFOCUSOUT) {
        context.parent.focusElPrevFocus()
        return
      }
      if (DELETE) {
        if (onDelete) {
          onDelete(item, index)
        } else {
          context.parent.$emit('delete', item, index)
        }
      }
      if (SELECT) {
        if (onSelect) {
          onSelect(item, index)
        } else {
          context.parent.$emit('select', item, index)
        }
        return
      } else if (FOCUSOUTPREV && prevFocusForce) {
        focusEl(prevFocusForce)
        return
      } else if (FOCUSOUTPREV) {
        focusEl(null)
        return
      }
      if (ARROW) {
        context.parent.$emit('arrow', { item, direction: e.key.replace('Arrow', '').toLowerCase() }, index)
        // focusEl(null)
        return
      }

      let inputs
      if (useVirtualScroll) {
        inputs = Jquery(e.target.parentNode.parentNode.parentNode).find('.selector-pw-item')
      } else {
        inputs = Jquery(e.target.parentNode.parentNode).find('.selector-pw-item')
      }

      let prev = null
      let next = null
      for (let index = 0; index < inputs.length; index++) {
        const item = inputs[index]
        if (item === e.target) {
          prev = inputs[index - 1]
          next = inputs[index + 1]
          break
        }
      }

      if (FOCUSPREV && prev) {
        focusEl(prev, index - 1)
      } else if (FOCUSNEXT && next) {
        focusEl(next, index + 1)
      }
      return false
    }

    const getStyle = () => {
      return `left: ${(20 * (level - 1))}px`
    }

    return (
      <div tabindex="0" class="selector-pw-item" style={getStyle()} onKeydown={ keypress } data-scroll-index={ index }>
        {$slots.default}
      </div>
    )
  }
})

export default {
  props: {
    items: {type: Array},
    itemHeight: {type: Number},
    useVirtualScroll: {type: Boolean, 'default': true},
    height: {type: String, 'default': '200px'},
    elPrevFocus: {} // TIP: use $refs.yourElement to use a element. You can also use a function here
  },
  methods: {
    isFirstEl (el) {
      return el === Jquery(this.$el).find('.selector-pw-item')[0]
    },
    focusLastBeforeContent () {
      if (this.useVirtualScroll) {
        this.$refs.scroller.scrollToItem(0)
      }
      let items = Jquery(this.$el).find('.selector-pw-item').toArray()
      items = items.filter(i => parseInt(i.dataset.index) < 0 && i !== document.activeElement)
      if (items[items.length - 1]) {
        items[items.length - 1].focus()
      } else if (this.elPrevFocus) {
        this.focusElPrevFocus()
      }
    },
    focusElPrevFocus () {
      if (typeof this.elPrevFocus === 'function') {
        this.elPrevFocus()
      } else {
        this.elPrevFocus.focus()
      }
    },
    focusFirst () {
      if (this.useVirtualScroll) {
        this.$refs.scroller.scrollToItem(0)
      }
      Jquery(this.$el).find('.selector-pw-item')[0].focus()
    },
    focusEl (el, index) {
      const currentFocused = document.activeElement
      if (!el) {
        this.focusLastBeforeContent()
        return
      }
      try {
        el.focus()
        if (this.useVirtualScroll) {
          this.$refs.scroller.setLastFocused(index)
        }
      } catch (e) {
        currentFocused.focus()
      }
    }
  },
  components: {VirtualScroller, SelectorItem}
}

</script>

<style scoped>
.selector-pw-container {
  overflow: auto;
  height: 100%;
  max-height: 100%;
}
</style>

<style>
.selector-pw-item {
  height: 26px !important;
  position: relative;
}
.selector-pw-item:hover {
  background-color: #e6e6e6;
}
.selector-pw-item:focus {
  background-color: gainsboro;
  outline: none;
}
</style>
